import { render, staticRenderFns } from "./KolomoiskyProperties.vue?vue&type=template&id=732a5a8e&"
import script from "./KolomoiskyProperties.vue?vue&type=script&lang=js&"
export * from "./KolomoiskyProperties.vue?vue&type=script&lang=js&"
import style0 from "./KolomoiskyProperties.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports